import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'https://api.doora.id/api';

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('admin_token');
      if (window.location.pathname.startsWith('/admin')) {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(err);
  }
);

// Auth
export const login = (username, password) => api.post('/auth/login', { username, password });

// Public
export const submitDemoRequest = (data) => api.post('/demo-request', data);
export const trackEvent = (data) => api.post('/analytics/track', data);

// Admin - Leads
export const getLeads = (params) => api.get('/admin/leads', { params });
export const getLead = (id) => api.get(`/admin/leads/${id}`);
export const updateLead = (id, data) => api.patch(`/admin/leads/${id}`, data);
export const deleteLead = (id) => api.delete(`/admin/leads/${id}`);

// Admin - CRM
export const getCRMPipeline = () => api.get('/admin/crm/pipeline');
export const getCRMActivities = (params) => api.get('/admin/crm/activities', { params });

// Admin - Analytics
export const getAnalyticsOverview = () => api.get('/admin/analytics/overview');
export const getGeography = () => api.get('/admin/analytics/geography');
export const getDemographics = () => api.get('/admin/analytics/demographics');

// Admin - Metrics
export const getBusinessMetrics = () => api.get('/admin/metrics/business');

export default api;
